/**
 * Help & Support Help Content
 * 
 * Feature: 136-dashboard-alignment (T058)
 * Pages: /help/docs, /help/runbooks, /help/support
 * Constitution: v1.12.0
 */

import type { PageHelpContent } from '../../components/ui/PageHelpPanel';

export const supportHelp: PageHelpContent = {
  pageTitle: 'Help & Support',
  purpose: 'Access documentation, operational runbooks, and support channels for the Fabric Control Plane.',
  sections: [
    {
      title: 'Documentation',
      paragraphs: [
        'Browse the documentation index for guides on using the Control Plane, API references, and integration instructions.',
      ],
    },
    {
      title: 'Operational Runbooks',
      paragraphs: [
        'Step-by-step procedures for common operational tasks: backup recovery, capacity scaling, alert triage, and incident response.',
      ],
      concepts: [
        { term: 'Runbook', definition: 'A documented procedure for handling a specific operational scenario, with steps, decision points, and escalation paths.' },
        { term: 'Incident Response', definition: 'Procedures for handling system outages or critical failures, including triage, communication, and resolution.' },
      ],
    },
    {
      title: 'Support Channels',
      paragraphs: [
        'For issues not covered by runbooks, use the support channels to reach the platform team. Include relevant alert IDs, timestamps, and affected resource details.',
      ],
    },
    {
      title: 'How To',
      steps: [
        { step: 1, instruction: 'Open the Documentation page to browse guides, API references, and integration instructions.' },
        { step: 2, instruction: 'Search the Operational Runbooks for step-by-step procedures matching your scenario.' },
        { step: 3, instruction: 'If the issue is not covered by a runbook, submit a support ticket with alert IDs, timestamps, and affected resources.' },
        { step: 4, instruction: 'Check the Known Issues list to see if your problem has already been reported and has a workaround.' },
      ],
    },
    {
      title: 'Related Pages',
      links: [
        { label: 'Dashboard', href: '/dashboard' },
        { label: 'Alerts', href: '/alerts' },
      ],
    },
  ],
};

export default supportHelp;
